export default class Portfolio {
  id?: string;

  name: string;

  businessUnitId: string;

  constructor(obj: any) {
    this.id = obj.id || null;
    this.name = obj.name || null;
    this.businessUnitId = obj.businessUnitId || null;
  }

  public static of(obj: any): Portfolio {
    return new Portfolio(obj || {});
  }

  public static ofList(obj: any[]): Portfolio[] {
    return obj.map(this.of);
  }
}
